import React from 'react'
import './preloaderLight.css'

const PreloaderLight = () => {
  return <div className='preloader-light'></div>
}

export default PreloaderLight
